export default __webpack_public_path__ + "static/media/Online.38b8d639.svg";